import { Environment, type FetchFunction, Network, RecordSource, Store } from 'relay-runtime';

function createFetchQuery(endpoint: string): FetchFunction {
  return async (params, variables) => {
    try {
      // Authentication is handled by the dev-server proxy
      // Don't send auth headers from the browser
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          query: params.text,
          variables,
        }),
      });

      // Handle redirect to login (from old middleware)
      if (response.headers.get('Content-type') === 'text/html' && response.status === 200 && response.url.indexOf('auth/login') > -1) {
        console.log('[Relay Environment] Redirecting to login');
        location.replace(response.url);
        return;
      }

      const json = await response.json();

      if (json.errors) {
        console.error('[Relay Environment] GraphQL errors:', json.errors);
      }

      return json;
    } catch (error) {
      console.error('[Relay Environment] Fetch error:', error);
      throw error;
    }
  };
}

export const publicEnvironment = new Environment({
  network: Network.create(createFetchQuery('/graphql')),
  store: new Store(new RecordSource()),
});

export const protectedEnvironment = new Environment({
  network: Network.create(createFetchQuery('/infoservice/graphql')),
  store: new Store(new RecordSource()),
});

export const anonymousEnvironment = new Environment({
  network: Network.create(createFetchQuery('/session/graphql')),
  store: new Store(new RecordSource()),
});
